<template>
  <app-layout>
    <div class="lading-one-destination">
      <app-banner-giftdestination :destination="destination || {}"></app-banner-giftdestination>
      <app-section-travel-icons :title="destination ? destination.landing_icons_title : ''" :bgColor="'#FFFFFF'" :textColor="'#000000'" :cards="sectionTravelIconsCards"></app-section-travel-icons>
      <app-section-optionals-icons :destination="destination"></app-section-optionals-icons>
      <app-section-info-icons :bgColor="'#FFFFFF'" :textColor="'#000000'"></app-section-info-icons>
      <app-banner-blog :destination="destination"></app-banner-blog>
      <app-destinies-container
        :title="$t('shared.destinations_one_day')"
        :btnLabel="$t('shared.discover_destinations')"
      ></app-destinies-container>
      <app-banner-newsletter></app-banner-newsletter>
    </div>
  </app-layout>
</template>

<script lang="ts">
import { mapActions } from "vuex";
import { FETCH_PLACES } from "../../store/destinies/action-types";
import { GIFTS_FIND_DESTINATION_FROM_SLUG, GIFTS_GET_SELECTED_DESTINATION, GIFTS_GET_SELECTED_DESTINATION_ORIGINS, GIFTS_GET_SELECTED_ORIGIN } from "../../store/gifts/getter-types";
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";

export default {
  computed: {
    origin() {
      return this.$store.getters[GIFTS_GET_SELECTED_ORIGIN];
    },
    destination() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION];
    },
    sectionTravelIconsCards() {
      if (! this.origin) return [];

      const images = ['icon-departure', 'destination-map', 'live-your-day', 'icon-arrival'];
      const cards = [];

      for (let i = 1; i <= 4; i++) {
        cards.push({
          image: `/img/icons/${images[i - 1]}.svg`,
          title: this.destination[`landing_text_${i}`],
          copy: this.destination[`landing_description_${i}`]
        });
      }

      return cards;
    },
  },
  methods: {
    ...mapActions({
      fetchPlaces: FETCH_PLACES
    }),
    getTime(field) {
      const time = this.destination.pivot[field];
      if (! time) return '';
      return time.slice(0, -3) + 'h';
    }
  },
  created() {
    this.fetchPlaces().catch(() => {
      this.$toastr.e(
        "Ha ocurrido un error durante la búsqueda. Inténtalo nuevamente."
      );
    });
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'gifts-destinations') {
      return next();
    }

    next(vm => {
      const destination = vm.$store.getters[GIFTS_FIND_DESTINATION_FROM_SLUG](to.params.slug);
      vm.$store.commit(SET_GIFTS_STATE, { prop: "destination_id", value: destination.id });
      vm.$store.commit(SET_GIFTS_STATE, { prop: "origin_id", value: vm.$store.getters[GIFTS_GET_SELECTED_DESTINATION_ORIGINS][0].id });
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
